import { useStaticQuery, graphql } from "gatsby";


const UseFooterQuery = () => {
    const { kontentItemFooterMenu } = useStaticQuery(graphql`
    query {
      kontentItemFooterMenu {
        elements {
          footer_logo__footer_logo {
            name
            value {
              url
              name
              width
              height
            }
          }
          footer_logo__footer_small_legal {
            value
            name
          }
          footer_main_menu {
            modular_content {
              ... on kontent_item_footer_menu_dynamic {
                id
                elements {
                  footer_menu_links__footer_menu_aria_label {
                    name
                    value
                  }
                  footer_menu_links__footer_menu_label_name {
                    name
                    value
                  }
                  footer_menu_links__footer_menu_link {
                    value
                    name
                  }
                  footer_menu_links__footer_open_in_new_tab {
                    value {
                      name
                    }
                    name
                  }
                }
              }
            }
          }
          footer_hours__footer_hours_component {
            modular_content {
              ... on kontent_item_footer_menu_dynamic {
                id
                elements {
                  footer_menu_links__footer_menu_aria_label {
                    value
                    name
                  }
                  footer_menu_links__footer_menu_label_name {
                    value
                    name
                  }
                  footer_menu_links__footer_menu_link {
                    value
                    name
                  }
                }
              }
            }
          }

        }
      }
    }

    `);

    return kontentItemFooterMenu.elements;
}

export default UseFooterQuery;